import { hc } from 'hono/client';
import { gzip } from 'pako';
import type { RestRouter } from '@app/server/src/router';

export const rest = hc<RestRouter>('/', { init: { credentials: 'include' } });

function normalizeHeaders(headers: HeadersInit | undefined): Record<string, string> {
  if (!headers) return {};
  if (headers instanceof Headers) return Object.fromEntries(headers.entries());
  if (Array.isArray(headers)) return Object.fromEntries(headers);
  return { ...headers };
}

const gzipFetch: typeof fetch = async (url, init = {}) => {
  if (init.body && typeof init.body === 'string') {
    const headers = normalizeHeaders(init.headers);
    headers['Content-Encoding'] = 'gzip';
    init.headers = headers;
    init.body = gzip(init.body);
  }
  return fetch(url, init);
};

export const restGzip = hc<RestRouter>('/', {
  init: { credentials: 'include' },
  fetch: gzipFetch,
});
